// src/components/tarifs/FeatureComparisonTable.js
import React from 'react';
import './FeatureComparisonTable.css';

// Définir la liste de toutes les fonctionnalités que nous voulons comparer
// L'ordre ici déterminera l'ordre dans la table
const allFeaturesList = [
  "Nombre de pages initial",
  "Design Personnalisé",
  "Blog intégré",
  "Optimisation SEO",
  "Support Technique",
  "Maintenance évolutive",
  "Formation à l'outil d'admin"
  // Ajoute d'autres fonctionnalités ici
];

function FeatureComparisonTable({ plans, features }) {
  if (!plans || plans.length === 0) {
    return null;
  }

  const featuresList = (Array.isArray(features) && features.length)
    ? features
    : allFeaturesList;

  const hasFeatureFromList = (plan, featureName) => {
    const list = Array.isArray(plan?.features) ? plan.features : [];
    const needle = String(featureName || '').toLowerCase();
    return list.some((f) => String(f || '').toLowerCase().includes(needle));
  };

  // Fonction pour afficher la valeur de la fonctionnalité, ou un symbole
  const renderFeatureValue = (value) => {
    if (typeof value === 'boolean') {
      return value ? <span className="check-mark">✓</span> : <span className="cross-mark">✗</span>;
    }
    if (value === undefined || value === null || value.trim() === '' || value.toLowerCase() === 'non') {
      return <span className="cross-mark">✗</span>;
    }
    if (value.toLowerCase() === 'oui' || value.toLowerCase() === 'inclus') {
        return <span className="check-mark">✓</span>;
    }
    return value; // Retourne le texte si ce n'est pas un simple oui/non
  };

  return (
    <section className="feature-comparison-container">
      <h2 className="section-title">Comparez nos Plans en Détail</h2>
      <div className="comparison-table-wrapper">
        <table className="comparison-table">
          <thead>
            <tr>
              <th>Fonctionnalités</th>
              {plans.map(plan => (
                <th key={plan.id}>{plan.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {featuresList.map(featureName => (
              <tr key={featureName}>
                <td className="feature-name">{featureName}</td>
                {plans.map(plan => (
                  <td key={`${plan.id}-${featureName}`} className="plan-cell">
                    {/* Accède à la valeur de la feature pour ce plan */}
                    {/* Assure-toi que tes données 'plan.featureDetails' existent et correspondent */}
                    {renderFeatureValue(
                      plan.featureDetails?.[featureName]
                      ?? (hasFeatureFromList(plan, featureName) ? 'Oui' : 'N/A')
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default FeatureComparisonTable;